import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TakePhotoPageRoutingModule } from './take-photo-routing.module';

import { TakePhotoPage } from './take-photo.page';
import { PhotoBillPreviewModule } from '@1bill-app/components/add-bill/upload-photo-bill/photo-bill-preview/photo-bill-preview.module';
import { UploadPhotoBillComponentModule } from '@1bill-app/components/add-bill/upload-photo-bill/upload-photo-bill.module';
import { SharedComponentsModule } from '@1bill-app/components/shared-components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TakePhotoPageRoutingModule,
    PhotoBillPreviewModule,
    UploadPhotoBillComponentModule,
    SharedComponentsModule,
  ],
  declarations: [TakePhotoPage],
})
export class TakePhotoPageModule {}
